export default __webpack_public_path__ + "static/media/cer5.40227f93.png";